/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */

var debounce = require('lodash/debounce');
var Swiper = require('swiper');

function initSwiper() {
    $('.swiper-wrapper').children('.experience-component').each(function () {
        $(this).addClass('swiper-slide');
    });

    var swiper = new Swiper('.swiper-container', {
        pagination: '.swiper-pagination',
        slidesPerView: 1,
        loop: true,
        centeredSlides: true,
        paginationClickable: true,
        keyboardControl: false,
        mousewheelControl: false,
        mousewheelForceToAxis: true,
        initialSlide: 0,
        longSwipes: true,
        pauseOnMouseEnter: true,
        autoplayDisableOnInteraction: false,
        autoplay: 5000,
        speed: 600,
        onSlideChangeEnd: function () {
            $('.swiper-slide').each(function () {
                var videoPlayer = $(this).find('iframe').get(0);

                if (videoPlayer) {
                    var playerSource = videoPlayer.src;

                    if (playerSource.includes('vimeo')) {
                        var vimeoPlayer = new Vimeo.Player(videoPlayer);
                        vimeoPlayer.pause();
                    } else {
                        videoPlayer.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                    }
                }
            });

            var activeVideo = $('.swiper-slide-active').find('iframe').get(0);
            if (activeVideo) {
                var activeVideoSource = activeVideo.src;

                if (activeVideoSource.includes('vimeo')) {
                    var activeVimeo = new Vimeo.Player(activeVideo);
                    activeVimeo.play();
                } else {
                    activeVideo.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
                }
            }
        }
    });

    $('.swiper-container').mouseenter(function () {
        swiper.stopAutoplay();
    });
    
    $('.swiper-container').mouseleave(function () {
        swiper.startAutoplay();
    });
    var reviewSlider = new Swiper('.swiper-reviews', {
        zoom: false,
        nextButton: '.button-next',
        prevButton: '.button-prev',
        pagination: '.swiper-pagination',
        paginationBulletRender: function (index, current) {
            return '<span class="swiper-pagination-bullet" data-index="' + (current+1) + '"><span class="' + (current+1) + '">' + (current+1) + '</span></span>';
        },
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        centeredSlides: true,
        paginationClickable: true,
        keyboardControl: false,
        mousewheelControl: false,
        mousewheelForceToAxis: true,
        paginationType: 'bullets'
    });

    if ($('.swiper-reviews .swiper-slide').length <= 1) {
        $('.reviews-pagination').removeClass('d-flex').addClass('d-none');
    }
}

/**
 * Get display information related to screen size
 * @param {jQuery} element - the current carousel that is being used
 * @returns {Object} an object with display information
 */
function screenSize(element) {
    var result = {
        itemsToDisplay: null,
        sufficientSlides: true
    };
    var viewSize = $(window).width();
    var extraSmallDisplay = element.data('xs');
    var smallDisplay = element.data('sm');
    var mediumDisplay = element.data('md');
    var numberOfSlides = element.data('number-of-slides');

    result.numberOfSlides = numberOfSlides;

    if (viewSize <= 575.98) {
        result.itemsToDisplay = extraSmallDisplay;
    } else if ((viewSize >= 576) && (viewSize <= 768.98)) {
        result.itemsToDisplay = smallDisplay;
    } else if (viewSize >= 769) {
        result.itemsToDisplay = mediumDisplay;
    }

    if (result.itemsToDisplay && numberOfSlides <= result.itemsToDisplay) {
        result.sufficientSlides = false;
    }

    return result;
}

/**
 * Makes the next element to be displayed next unreachable for screen readers and keyboard nav
 * @param {jQuery} element - the current carousel that is being used
 */
function hiddenSlides(element) {
    var carousel;

    if (element) {
        carousel = element;
    } else {
        carousel = $('.experience-commerce_layouts-carousel .carousel, .experience-einstein-einsteinCarousel .carousel, .experience-einstein-einsteinCarouselCategory .carousel, .experience-einstein-einsteinCarouselProduct .carousel');
    }
    carousel.each(function () {
        var screenSizeInfo = screenSize($(this));
        var nSlides = screenSizeInfo.numberOfSlides;
        var lastDisplayedElement;
        var elementToBeDisplayed;
        var elementToBeDisplayedPos;
        var lastElemPos;
        var activeItemPos = $(this).find('.active.carousel-item').data('position');
        var noVisibleItem = $(this).find('.carousel-item[tabindex=-1]');
        
        // remove tabindex from all elements
        if (noVisibleItem) {
            noVisibleItem.removeAttr('tabindex').removeAttr('aria-hidden');
            noVisibleItem.find('a, button, details, input, textarea, select')
                .removeAttr('tabindex')
                .removeAttr('aria-hidden');
        }
        
        switch (screenSizeInfo.itemsToDisplay) {           
            case 2:
                lastElemPos = activeItemPos + 1;
                if (lastElemPos >= nSlides) {
                    lastElemPos -= nSlides;
                }
                lastDisplayedElement = $(this).find(`.carousel-item[data-position='${lastElemPos}']`);
                elementToBeDisplayedPos = lastElemPos + 1;
                if (elementToBeDisplayedPos >= nSlides) {
                    elementToBeDisplayedPos -= nSlides;
                }
                elementToBeDisplayed = $(this).find(`.carousel-item[data-position='${elementToBeDisplayedPos}']`);
                break;
            case 3:
                lastElemPos = activeItemPos + 2;
                if (lastElemPos >= nSlides) {
                    lastElemPos -= nSlides;
                }
                lastDisplayedElement = $(this).find(`.carousel-item[data-position='${lastElemPos}']`);
                elementToBeDisplayedPos = lastElemPos + 1;
                if (elementToBeDisplayedPos >= nSlides) {
                    elementToBeDisplayedPos -= nSlides;
                }
                elementToBeDisplayed = $(this).find(`.carousel-item[data-position='${elementToBeDisplayedPos}']`);
                break;
            case 4:
                lastElemPos = activeItemPos + 3;
                if (lastElemPos >= nSlides) {
                    lastElemPos -= nSlides;
                }
                lastDisplayedElement = $(this).find(`.carousel-item[data-position='${lastElemPos}']`);
                elementToBeDisplayedPos = lastElemPos + 1;
                if (elementToBeDisplayedPos >= nSlides) {
                    elementToBeDisplayedPos -= nSlides;
                }
                elementToBeDisplayed = $(this).find(`.carousel-item[data-position='${elementToBeDisplayedPos}']`);
                break;
            case 6:
                lastElemPos = activeItemPos + 5;
                if (lastElemPos >= nSlides) {
                    lastElemPos -= nSlides;
                }
                lastDisplayedElement = $(this).find(`.carousel-item[data-position='${lastElemPos}']`);
                elementToBeDisplayedPos = lastElemPos + 1;
                if (elementToBeDisplayedPos >= nSlides) {
                    elementToBeDisplayedPos -= nSlides;
                }
                elementToBeDisplayed = $(this).find(`.carousel-item[data-position='${elementToBeDisplayedPos}']`);
                break;
            default:
                break;
        }

        $(this).find('.active.carousel-item').removeAttr('tabindex').removeAttr('aria-hidden');
        $(this).find('.active.carousel-item').find('a, button, details, input, textarea, select')
            .removeAttr('tabindex')
            .removeAttr('aria-hidden');

        if (lastDisplayedElement) {
            lastDisplayedElement.removeAttr('tabindex').removeAttr('aria-hidden');
            lastDisplayedElement.find('a, button, details, input, textarea, select')
                .removeAttr('tabindex')
                .removeAttr('aria-hidden');
        }

        if (elementToBeDisplayed) {
            elementToBeDisplayed.attr('tabindex', -1).attr('aria-hidden', true);
            elementToBeDisplayed.find('a, button, details, input, textarea, select')
                .attr('tabindex', -1)
                .attr('aria-hidden', true);
        }
        
        // add the data outofinitview equal to true to the elements that are not visible
        var items = $(this).find('.carousel-item');
        for (var i = 0; i < items.length; i++) {
            if (items.eq(i).attr('data-position') >= screenSizeInfo.itemsToDisplay && !items[i].hasAttribute('data-outofinitview')) {
                items.eq(i).attr('data-outofinitview', true);
            }
        }
    });
}

$(document).ready(function () {
    hiddenSlides();

    $(window).on('resize', debounce(function () {
        hiddenSlides();
    }, 500));

    $('body').on('carousel:setup', function () {
        hiddenSlides();
    });

    $('.experience-commerce_layouts-carousel .carousel, .experience-einstein-einsteinCarousel .carousel, .experience-einstein-einsteinCarouselCategory .carousel, .experience-einstein-einsteinCarouselProduct .carousel').on('touchstart', function (touchStartEvent) {
        var screenSizeInfo = screenSize($(this));

        if (screenSizeInfo.sufficientSlides) {
            var xClick = touchStartEvent.originalEvent.touches[0].pageX;
            $(this).one('touchmove', function (touchMoveEvent) {
                var xMove = touchMoveEvent.originalEvent.touches[0].pageX;
                if (Math.floor(xClick - xMove) > 5) {
                    $(this).carousel('next');
                } else if (Math.floor(xClick - xMove) < -5) {
                    $(this).carousel('prev');
                }
            });
            $('.experience-commerce_layouts-carousel .carousel, .experience-einstein-einsteinCarousel .carousel, .experience-einstein-einsteinCarouselCategory .carousel, .experience-einstein-einsteinCarouselProduct .carousel').on('touchend', function () {
                $(this).off('touchmove');
            });
        }
    });

    $('.experience-commerce_layouts-carousel .carousel, .experience-einstein-einsteinCarousel .carousel, .experience-einstein-einsteinCarouselCategory .carousel, .experience-einstein-einsteinCarouselProduct .carousel').on('slide.bs.carousel', function (e) {
        var activeCarouselPosition = $(e.relatedTarget).data('position');
        $(this).find('.pd-carousel-indicators .active').removeClass('active');
        $(this).find('.pd-carousel-indicators [data-position=\'' + activeCarouselPosition + '\']').addClass('active');

        var extraSmallDisplay = $(this).data('xs');
        var smallDisplay = $(this).data('sm');
        var mediumDisplay = $(this).data('md');

        var arrayOfSlidesToDisplay = [];

        if (!$(this).hasClass('insufficient-xs-slides')) {
            arrayOfSlidesToDisplay.push(extraSmallDisplay);
        }

        if (!$(this).hasClass('insufficient-sm-slides')) {
            arrayOfSlidesToDisplay.push(smallDisplay);
        }

        if (!$(this).hasClass('insufficient-md-slides')) {
            arrayOfSlidesToDisplay.push(mediumDisplay);
        }

        var itemsToDisplay = Math.max.apply(Math, arrayOfSlidesToDisplay);

        var elementIndex = $(e.relatedTarget).index();
        var numberOfSlides = $('.carousel-item', this).length;
        var carouselInner = $(this).find('.carousel-inner');
        var carouselItem;

        if (elementIndex >= numberOfSlides - (itemsToDisplay - 1)) {
            var it = itemsToDisplay - (numberOfSlides - elementIndex);
            for (var i = 0; i < it; i++) {
                // append slides to end
                if (e.direction === 'left') {
                    carouselItem = $('.carousel-item', this).eq(i);

                    $(carouselItem).appendTo($(carouselInner));
                } else {
                    carouselItem = $('.carousel-item', this).eq(0);

                    $(carouselItem).appendTo($(carouselInner));
                }
            }
        }
    });

    $('.experience-commerce_layouts-carousel .carousel, .experience-einstein-einsteinCarousel .carousel, .experience-einstein-einsteinCarouselCategory .carousel, .experience-einstein-einsteinCarouselProduct .carousel').on('slid.bs.carousel', function () {
        hiddenSlides($(this));
    });
    
    var initPosition = 0;
    var isDragging = false;

    $('.experience-commerce_assets-carouselrecommendation .carousel')
        .mousedown(function () {
            initPosition = window.event.clientX;
            isDragging = false;
        })
        .mousemove(function () {
            isDragging = true;
        })
        .mouseup(function () {
            var wasDragging = isDragging;
            isDragging = false;
            if (wasDragging) {
                var newPosition = window.event.clientX;
                var calculated = initPosition - newPosition;
                if (calculated < 0) {
                    $('.experience-commerce_assets-carouselrecommendation .carousel').carousel('prev');
                } else if (calculated > 0) {
                    $('.experience-commerce_assets-carouselrecommendation .carousel').carousel('next');
                }
            }
        });
    $('.experience-commerce_assets-carouselrecommendation').on('dragstart', function (event) { 
        event.preventDefault();
    });

    initSwiper();
});
